export const ACTIONS = {
    CMTSDATA: 'CMTSDATA',
    CONTENTCARDDATA: 'CONTENTCARDDATA',
    TAGS: 'TAGS',
    CONTENTSETTINGS: 'CONTENTSETTINGS',
    CONTENTTYPES: 'CONTENTTYPES',
    GROUPRADARID:'GROUPRADARID',
    GETRADARDATAACTION:'GETRADARDATAACTION',
    CURRENTINDEXEDITINGHISTORY: 'CURRENTINDEXEDITINGHISTORY',
    LANGFORTRANSSTATE: 'LANGFORTRANSSTATE',
    ISAUTOTRANS: 'ISAUTOTRANS',
    LANGLISTOPTIONS: 'LANGLISTOPTIONS',
    GETWHOLEHTMLCARD1: 'GETWHOLEHTMLCARD1',
    GETWHOLEHTMLCARD2: 'GETWHOLEHTMLCARD2',
    GETWHOLEHTMLCARD3: 'GETWHOLEHTMLCARD3',
    GETWHOLEHTMLCARD4: 'GETWHOLEHTMLCARD4',
    GETWHOLEHTMLCARD5: 'GETWHOLEHTMLCARD5',
    GETWHOLEHTMLCARD6: 'GETWHOLEHTMLCARD6',
    GETWHOLEHTMLCARD7: 'GETWHOLEHTMLCARD7',
    GETWHOLEHTMLCARD8: 'GETWHOLEHTMLCARD8',
    GETWHOLEHTMLCARD9: 'GETWHOLEHTMLCARD9',
    GETWHOLEHTMLCARD10: 'GETWHOLEHTMLCARD10',
    GETWHOLEHTMLCARD11: 'GETWHOLEHTMLCARD11',
    ISTRANSLATED: 'ISTRANSLATED',
    ISLOADING: 'ISLOADING',
    DATAFORTRANSLATIONCARDBODY: 'DATAFORTRANSLATIONCARDBODY',
    DATAFORTRANSLATIONTYPEIMAGE: 'DATAFORTRANSLATIONTYPEIMAGE',
    DATAFORTRANSLATIONFROMCARDHEADER: 'DATAFORTRANSLATIONFROMCARDHEADER',
    CROWDSOURCED: 'CROWDSOURCED',
    SET_PDF_EXPORT_LOADING: 'SET_PDF_EXPORT_LOADING',
    SET_PUBLIC_PHENOMENA_GROUPS: "SET_PUBLIC_PHENOMENA_GROUPS",
    SET_3RD_PARTY_PHENOMENA_GROUPS: "SET_3RD_PARTY_PHENOMENA_GROUPS",
    SET_USER_GROUPS: "SET_USER_GROUPS",
}